import { ChangeEvent } from 'react';
import { OpenComponent } from '../../enums/misc.enum';
import { BasicAccount } from '../../type/retrieve-account.types';
import StatusText from '../admin-table/components/status-text.component';
import XSafeTextInfo from '../x-components/x-safe-text-info.component';
import XThead from '../x-components/x-table-header.component';
import XTable from '../x-components/x-table/x-table.component';
interface Props {
  accountsData: BasicAccount[];
  isChecked: number[];
  setIsChecked: React.Dispatch<React.SetStateAction<number[]>>;
  checkedAll: boolean;
  setCheckedAll: React.Dispatch<React.SetStateAction<boolean>>;
  isLoading: boolean;
  setComponentManager: React.Dispatch<React.SetStateAction<OpenComponent>>;
  setClickedUserId: React.Dispatch<React.SetStateAction<number | undefined>>;
}

function UserAccountsTable(props: Props) {
  const {
    accountsData,
    isChecked,
    setIsChecked,
    checkedAll,
    setCheckedAll,
    isLoading,
    setComponentManager,
    setClickedUserId,
  } = props;

  const navigateUser = (id: number) => {
    setClickedUserId(id);
    setComponentManager(OpenComponent.VIEW_USER);
  };

  const handleCheck = (e: ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = e.target;
    if (checked) {
      setIsChecked([...isChecked, Number(id)]);
    } else {
      setIsChecked(isChecked.filter((item) => item !== Number(id)));
    }
  };

  const handleCheckAll = () => {
    if (!accountsData) {
      return;
    }
    let arr = accountsData;
    setCheckedAll(!checkedAll);

    if (checkedAll) {
      setIsChecked([]);
    } else {
      setIsChecked(arr.map((li) => li.accountId));
    }
  };
  return (
    <>
      <XTable>
        <XThead>
          <tr>
            {/* <th style={{ width: 30 }}>
              <input
                type='checkbox'
                style={{ cursor: 'pointer' }}
                onChange={handleCheckAll}
                checked={checkedAll}
              />
            </th> */}
            <th>Full name</th>
            <th>City</th>
            <th>State</th>
            <th>Country</th>
            <th>Contact number</th>
            <th>Status</th>
          </tr>
        </XThead>
        <tbody>
          {accountsData.map((account) => {
            return (
              <tr>
                {/* <td>
                  <input
                    type='checkbox'
                    style={{ cursor: 'pointer' }}
                    id={account.accountId.toString()}
                    checked={isChecked.includes(account.accountId)}
                    onChange={handleCheck}
                  />
                </td> */}
                <td onClick={() => navigateUser(account.accountId)}>
                  <XSafeTextInfo
                    data={
                      (account.user.firstName || '') +
                      ' ' +
                      `${
                        account.user.middleName &&
                        account.user.middleName !== 'N/A' &&
                        account.user.middleName !== '.'
                          ? account.user.middleName
                          : ''
                      }` +
                      ' ' +
                      (account.user.lastName || '')
                    }
                  />
                </td>
                <td onClick={() => navigateUser(account.accountId)}>
                  {account.user.address.city}
                </td>
                <td onClick={() => navigateUser(account.accountId)}>
                  <XSafeTextInfo data={account.user.address.state} />
                </td>
                <td onClick={() => navigateUser(account.accountId)}>
                  <XSafeTextInfo
                    data={
                      account.user.address?.countryId === 1 ? 'Philippines' : ''
                    }
                  />
                </td>
                <td onClick={() => navigateUser(account.accountId)}>
                  <XSafeTextInfo data={account.contact.phone.primary} />
                </td>
                <td onClick={() => navigateUser(account.accountId)}>
                  <StatusText
                    status={account.isActive ? 'ENABLED' : 'DISABLED'}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </XTable>
    </>
  );
}

export default UserAccountsTable;
